import { log } from '@/log'
import { ApiClientWithAuth } from '@/services/api/client'
import { Either, left, right } from 'fp-ts/lib/Either'

export class PointService {
  static createDefault(): PointService {
    return new PointService()
  }

  private constructor() {}

  async getAggregated(query: object = {}): Promise<Either<Error, AggregatedPoint[]>> {
    try {
      const res = await ApiClientWithAuth.get('/api/user/point/aggregated', query)

      return right(res.body.data)
    } catch (error) {
      log.error({ error })

      return left(error)
    }
  }

  async getApplicable(query: ApplicablePointQuery): Promise<Either<Error, ApplicablePoint>> {
    try {
      const res = await ApiClientWithAuth.get('/api/user/point/applicable', query)

      return right(res.body.data)
    } catch (error) {
      log.error({ error })

      return left(error)
    }
  }
}

export interface Point {
  readonly point: number
  readonly expired_at: string
  readonly last_available_at: string
}
export interface AggregatedPoint extends Point {
  readonly sources: Readonly<Point[]>
}

export interface ApplicablePointQuery {
  /** 商品の合計価格 */
  item_price: number
  /** 手数料 */
  commission: number
  /** 送料 */
  delivery_fee: number
}
interface ApplicablePoint {
  /** 適用可能なポイント */
  readonly applicable: number
  /** 所持ポイント */
  readonly possession: number
}
